import { getMyTaskList, setMyTaskList } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人商品列表
      myTaskList: getMyTaskList()
    }
  },
  getters: {

  },
  mutations: {
    setMyTaskList (state, obj) {
      state.myTaskList = obj
      setMyTaskList(obj)
    }
  },
  actions: {
  }
}
